import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComposeEmailsService {

  constructor(
    private http: HttpClient,
  ) { }

  sendEmail(data: any): Observable<any> {
    return this.http.post(`${environment.yiiUrl}emails/send`, data);
  }
  sendMailToMailBox(data: any): Observable<any> {
    return this.http.post(`${environment.yiiUrl}emails/send-mail-to-mailbox`, data);
  } 
}
